import type { Address } from 'viem';
import type { EncodedTx } from '../types.js';
import type { ClientMode } from '../config.js';
import { SelfSignerStrategy } from './self.js';
import { DelegatedSignerStrategy } from './delegated.js';

export interface SignerStrategy {
  /**
   * The on-chain trading account. Used as trade.trader in all contract calls
   * and as the owner of USDC allowances.
   */
  readonly traderAddress: Address;

  /**
   * Prepare a transaction for submission.
   * - Self mode: returns tx unchanged.
   * - Delegated mode: wraps data in delegatedAction(traderAddress, data).
   */
  prepare(encoded: EncodedTx): EncodedTx;
}

/**
 * @param selfGasless - true when in Self + Gasless mode (EOA = trader, Safe = delegate).
 *   In this mode we use DelegatedSignerStrategy even though `traderAddress` is not set
 *   in the config — the Safe submits delegatedAction(eoaAddress, callData) on behalf of
 *   the EOA, so all contract calls must be wrapped.
 */
export function createSigner(
  mode: ClientMode,
  traderAddress: Address,
): SignerStrategy {
  if (mode !== 'self-self') {
    return new DelegatedSignerStrategy(traderAddress);
  }
  return new SelfSignerStrategy(traderAddress);
}
